import React, { useState, useEffect } from "react";

import { getExtensiones } from "../../../../API/IT/Dispositivos/DispositivosRequest";
import AgGrid from "../../../../Base/Components/Tables/AgGrid/AgGrid";

const Extensiones = () => {
  const [Extensiones, setExtensiones] = useState([]);

  const columns = [
    {
      // Empleado
      field: "NombreCompletoPrimer",
      header: "Personal",
      headerEn: "Personal",
      className: "large",
    },
    {
      // Extension
      field: "Extension",
      header: "Extension",
      className: "small",
      Format: "Modal",
    },
    {
      // Correo
      field: "Correo",
      header: "Correo",
      className: "large",
    },
    {
      // Departamento
      field: "Area",
      header: "Area",
      className: "medium",
    },
    {
      // TelefonoPersonal
      field: "Telefono",
      header: "Telefono personal",
      headerEn: "Personal Phone",
      flex: 1,
      minWidth: 100,
    },
  ];

  const table = {
    Columns: columns,
    Data: Extensiones,
  };

  const getExtencionesData = async () => {
    const tempo = await getExtensiones();
    setExtensiones(tempo);
  };

  useEffect(() => {
    getExtencionesData();
  }, []);

  return (
    <div style={{ height: "62vh" }}>
      <AgGrid table={table} />
    </div>
  );
};

export default Extensiones;
